var map = {
	"./borrow.svg": "b124",
	"./repay.svg": "9896",
	"./supply.svg": "37b3",
	"./txnComplete.svg": "7fa7",
	"./txnComplete2.svg": "0de1",
	"./txnFailed.svg": "562d",
	"./txnNotStarted.svg": "9a7a",
	"./txnPending.svg": "52f1",
	"./withdraw.svg": "ca15"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c86";